import jump from 'jump.js'
import viewport from './viewport.js'

const arrow = () => {
  // cache arrow
  const arrow = document.querySelector('.couple-arrow')

  // exit early if no arrow found
  if (!arrow) return

  // cache next section
  let next = arrow

  while (next.parentNode) {
    next = next.parentNode

    if (next.classList.contains('section')) {
      break
    }
  }

  next = next.nextElementSibling

  // create handler
  const handler = event => {
    event.preventDefault()

    // find offset in px to center the next section
    const offset = -(viewport.height - next.clientHeight) / 2

    jump(next, {
      duration: 1000,
      offset
    })
  }

  // bind event
  arrow.addEventListener('click', handler)
}

export default arrow
